import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M20.57 5.14c-1.71 0-2.57 0-3.43-.86-.86-.86-1.75-2.13-4.29-1.71-.67.11-2.57.86-2.57.86S12.85 0 11.14 0 6 1.29 6 6c0 2.57-.43 3-1.71 5.14H6l-1.71 3.43h11.57c0-2.57 1.29-3.43 3.86-3.43s3.86-2.57 4.29-6h-3.44Zm-5.14 1.71h-.86v-.86c0-.47.38-.86.86-.86s.86.38.86.86-.38.86-.86.86Z" />
    <path d="M13.71 16.29H3.28c-.21-.67-.64-1.42-1.33-2.1-1.24-1.24-2.73.24-1.48 1.48 1 1 2.1 1.48 2.1 1.48s-1.11.48-2.1 1.48c-1.24 1.24.24 2.73 1.48 1.48.77-.77 1.31-1.8 1.48-2.53 7.56 6.23 18 6.43 18 6.43s-1.3-2.67-2.51-5.12c-.78-1.59-2.63-2.59-5.2-2.59l-.01-.01Z" />
  </>
);

const CollDogFriendly = Icon('coll-dog-friendly', svgContents);

export default CollDogFriendly;
